import React from 'react';

const LivePerformance = () => {
    return (
        <div className="w-full h-full flex items-center justify-center">
        </div>
    );
};

export default LivePerformance;